import {User} from '@deviceinsight/ng-ui-api-client';

type UserStoreType = {
	user: User | null | undefined;
	lastLoggedInUser: User | null | undefined;
	setUser: (arg0: User | null | undefined) => void;
	setLastLoggedInUser: (arg0: User | null | undefined) => void;
	getUser: () => User;
	getLastLoggedInUser: () => User;
};
const UserStore: UserStoreType = {
	user: undefined,
	lastLoggedInUser: undefined,
	setUser: function (user: User | null | undefined) {
		this.user = user;
	},
	setLastLoggedInUser: function (user: User | null | undefined) {
		this.lastLoggedInUser = user;
	},
	getUser: function () {
		return this.user as User;
	},
	getLastLoggedInUser: function () {
		return this.lastLoggedInUser as User;
	}
};
export default UserStore;
